import UpdateThirdParty from "./UpdateThirdParty.container";

export default UpdateThirdParty;
